import PageLayout from '../../components/feature/PageLayout';
import PageHero from '../../components/feature/PageHero';
import SEO from '../../components/feature/SEO';
import CarsListing from './components/CarsListing';
import { Link } from 'react-router-dom';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

const compraventaJsonLd = [
  {
    '@context': 'https://schema.org',
    '@type': 'AutoDealer',
    name: 'Taller Mecánico Kevin Alberto – Compraventa de Vehículos',
    url: `${siteUrl}/compraventa`,
    telephone: '+34666365922',
    email: 'tallerkevinalberto@gmail.com',
    description:
      'Compraventa de vehículos de ocasión en Ronda, Málaga. Coches seleccionados, revisados y con garantía. Tasación gratuita y financiación disponible.',
    address: {
      '@type': 'PostalAddress',
      streetAddress: 'C. Guadalimar, 7',
      addressLocality: 'Ronda',
      postalCode: '29400',
      addressRegion: 'Málaga',
      addressCountry: 'ES',
    },
    geo: {
      '@type': 'GeoCoordinates',
      latitude: '36.7450',
      longitude: '-5.1679',
    },
    openingHoursSpecification: [
      {
        '@type': 'OpeningHoursSpecification',
        dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
        opens: '07:00',
        closes: '15:00',
      },
    ],
    priceRange: '€€',
  },
  {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: 'Compraventa de Coches de Ocasión en Ronda Málaga | Taller Kevin Alberto',
    url: `${siteUrl}/compraventa`,
    description:
      'Vehículos de ocasión revisados y garantizados en Ronda, Málaga. Tasación gratuita de tu coche. Financiación disponible.',
    inLanguage: 'es',
    isPartOf: { '@type': 'WebSite', url: siteUrl },
  },
];

const CompraventaPage = () => (
  <PageLayout>
    <SEO
      title="Compraventa Coches de Ocasión Ronda Málaga | Taller Kevin Alberto"
      description="Coches de ocasión revisados y con garantía en Ronda, Málaga. Tasación gratuita de tu vehículo, financiación disponible. Taller Mecánico Kevin Alberto — compra y venta en Ronda."
      keywords="compraventa coches Ronda, coches ocasión Ronda Málaga, vender coche Ronda, comprar coche usado Ronda"
      canonical="/compraventa"
      jsonLd={compraventaJsonLd}
    />
    <PageHero
      tag="Vehículos de ocasión"
      title="Compra"
      titleAccent="Venta"
      subtitle="Coches seleccionados, revisados y con garantía en nuestro taller. Financiación disponible."
      breadcrumb="Compraventa"
      bgImage="https://public.readdy.ai/ai/img_res/279cda75774914a46babcf72b4d10de8.jpg"
    />
    <CarsListing />

    {/* Sell your car */}
    <section className="bg-black py-14 px-4">
      <div className="max-w-7xl mx-auto">
        <div className="border border-zinc-800 bg-zinc-900 p-8 md:p-12 flex flex-col md:flex-row items-center justify-between gap-8">
          <div>
            <p className="text-yellow-400 text-xs font-bold uppercase tracking-[0.3em] mb-2 flex items-center gap-2">
              <span className="w-5 h-px bg-yellow-400" />
              ¿Quieres vender tu coche?
            </p>
            <h2 className="text-2xl md:text-3xl font-black text-white uppercase leading-none mb-3">
              Tasación <span className="text-yellow-400">gratuita</span>
            </h2>
            <p className="text-zinc-500 text-sm leading-relaxed max-w-md">
              Compramos tu vehículo al mejor precio. Tráelo, lo valoramos y te hacemos una oferta en el acto sin ningún compromiso.
            </p>
            <ul className="mt-4 space-y-1.5">
              {['Tasación inmediata y sin compromiso', 'Pago al contado en el momento', 'Gestionamos todos los trámites'].map(item => (
                <li key={item} className="flex items-center gap-2 text-zinc-400 text-sm">
                  <i className="ri-check-line text-yellow-400 text-xs" />
                  {item}
                </li>
              ))}
            </ul>
          </div>
          <Link
            to="/contacto"
            className="flex-shrink-0 inline-flex items-center gap-2 bg-yellow-400 text-black font-black text-xs uppercase tracking-widest px-8 py-4 hover:bg-yellow-300 transition-all cursor-pointer whitespace-nowrap"
          >
            Vender mi coche <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </div>
    </section>
  </PageLayout>
);

export default CompraventaPage;
